
<div [ngClass]="{
  'distaction-question-type-1': 1
}">
  <div class="content-container">
    <h2 [innerHTML]="question"></h2>
    <div class="options-container">
      <ul class="list-group" [ngClass]="{'vertical': vertical}">
        @for (option  of answers; track option ; let i = $index) {
          <li
            class="list-group-item"
            [ngClass]="{'selected': option.selected}"
            >
            @if (vertical) {
              <div class="option-indicator">
                @if (!option.valid) {
                  <div class="wrong">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z"/>
                        <path fill="#FF495C" d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                      </g>
                    </svg>
                  </div>
                }
                @if (option.valid) {
                  <div class="correct">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z"/>
                        <path fill="#6DCC09" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2-4.58l9-9L17.59 7 10 14.59l-3.59-3.58L5 12.42l5 5z"/>
                      </g>
                    </svg>
                  </div>
                }
              </div>
            }
            <button
              id='option-{{option.label}}'
              class="option-button"
              [ngClass]="{'correct': option.valid, 'wrong': !option.valid}"
              (click)="onAnswer(option)"
              [innerHTML] = "option.label"
              >
            </button>
            @if (!vertical) {
              <div class="option-indicator">
                @if (!option.valid) {
                  <span class="wrong">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z"/>
                        <path fill="#FF495C" d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                      </g>
                    </svg>
                  </span>
                }
                @if (option.valid) {
                  <span class="correct">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h24v24H0z"/>
                        <path fill="#6DCC09" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2-4.58l9-9L17.59 7 10 14.59l-3.59-3.58L5 12.42l5 5z"/>
                      </g>
                    </svg>
                  </span>
                }
              </div>
            }
          </li>
        }
      </ul>
    </div>
    <div style="margin-top:20px;">
      @if (selectedCorrectAnswer) {
        <button id="nextD" (click)="onNext()" class="btn btn-outline hover active" value="Next">Next</button>
      }
      @if (!selectedCorrectAnswer) {
        <div style="height:48px"></div>
      }
    </div>
  </div>
</div>
